/* global axios */
import ApiClient from './ApiClient';

class ResolutionReasonsApi extends ApiClient {
  constructor() {
    super('resolution_reasons', { accountScoped: true });
  }

  getActive() {
    return axios.get(this.url, { params: { active: true } });
  }
}

export default new ResolutionReasonsApi();
